import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

import HomePage from "./pages/homePage/HomePage";
import ServicePage from "./pages/servicePage/ServicePage";
import AboutPage from "./pages/aboutPage/AboutPage";
import ContactPage from "./pages/contactPage/ContactPage";
import UsedGearPage from "./pages/usedGearPage/UsedGearPage";
import CookieBanner from "./components/cookieBanner/CookieBanner";
import "./index.css";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";
import PortfolioPage from "./pages/portfolioPage/PortfolioPage";


// Starta google analytics
ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID || "G-XXXXXXXXXX");

const App: React.FC = () => {
  const location = useLocation();

  //kollar ändringar i routes åt analytics
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  const isPortfolio = location.pathname === '/portfolio'

  return (
    <div className={`page-container ${isPortfolio ? "wide-portfolio" : ""}`}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/skidservice" element={<ServicePage />} />
        <Route path="/om" element={<AboutPage />} />
        <Route path="/kontakt" element={<ContactPage />} />
        <Route path="/begagnat" element={<UsedGearPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
      </Routes>
      <CookieBanner />
    </div>
  );
};

export default App;